import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CheckBox, CheckBoxOutlineBlankOutlined } from '@mui/icons-material';
import { Checkbox, FormControlLabel } from '@mui/material';
import './UserPermissions.scss';
import Scroller from 'ui-component/Scroller';
import toast from 'react-hot-toast';
import usePermissions from 'hooks/usePermissions';

const UserPermissions = ({ onClose, data }) => {
	const [allPerms, hasPerms] = usePermissions();

	const [userPermissionsList, setUserPermissionsList] = useState([]);

	// const userPermissions = ;

	useEffect(() => {
		setUserPermissionsList(data?.permissions);
	}, [data]);


	/* ----------------------------------------
	   Helpers
	---------------------------------------- */

	const isModuleChecked = (module) => {
		return module?.permissions?.every((perm) =>
			perm?.page_events?.every((e) => e?.has_permission)
		);
	};

	/* ----------------------------------------
	   Single Permission Toggle
	---------------------------------------- */

	const handlePermissionEventCheck = (event_id, perm_id, group_id) => {
		const newValue = [...userPermissionsList]
			?.find((module) => module?.id == group_id)
			?.permissions?.find((perm) => perm?.id == perm_id)
			?.page_events?.find((e) => e?.id == event_id)?.has_permission
			? 0
			: 1;

		setUserPermissionsList((oldData) => {
			const copy = [...oldData];
			const permEvent = copy
				?.find((module) => module?.id == group_id)
				?.permissions?.find((perm) => perm?.id == perm_id)
				?.page_events?.find((e) => e?.id == event_id);
			permEvent.has_permission = newValue;
			return copy;
		});

		//Get API Response and repeat above 3 lines along with the last line only if success

		if(data?.role) {
			toast.promise(
				api
					.updateRolePermissions(data?.role?.id, {
						is_checked: newValue,
						page_event_ids: [event_id]
					})
					.then((res) => {
						if (res?.status) {
						} else {
							setUserPermissionsList((oldData) => {
								const copy = [...oldData];
								const permEvent = copy
									?.find((module) => module?.id == group_id)
									?.permissions?.find((perm) => perm?.id == perm_id)
									?.page_events?.find((e) => e?.id == event_id);
								permEvent.has_permission = newValue ? 0 : 1;
								return copy;
							});
						}
	
						return res?.status ? res : null;
					})
					.catch(() => {
						setUserPermissionsList((oldData) => {
							const copy = [...oldData];
							const permEvent = copy
								?.find((module) => module?.id == group_id)
								?.permissions?.find((perm) => perm?.id == perm_id)
								?.page_events?.find((e) => e?.id == event_id);
							permEvent.has_permission = newValue ? 0 : 1;
							return copy;
						});
					}),
				{
					loading: 'Updating Permission...',
					success: (data) => `${data.message}`,
					error: <b>Failed to update permission.</b>
				}
			);
		} else {
			toast.promise(
				api
					.updateUserPermissions(data?.user?.id, {
						is_checked: newValue,
						page_event_ids: [event_id]
					})
					.then((res) => {
						if (res?.status) {
						} else {
							setUserPermissionsList((oldData) => {
								const copy = [...oldData];
								const permEvent = copy
									?.find((module) => module?.id == group_id)
									?.permissions?.find((perm) => perm?.id == perm_id)
									?.page_events?.find((e) => e?.id == event_id);
								permEvent.has_permission = newValue ? 0 : 1;
								return copy;
							});
						}
	
						return res?.status ? res : null;
					})
					.catch(() => {
						setUserPermissionsList((oldData) => {
							const copy = [...oldData];
							const permEvent = copy
								?.find((module) => module?.id == group_id)
								?.permissions?.find((perm) => perm?.id == perm_id)
								?.page_events?.find((e) => e?.id == event_id);
							permEvent.has_permission = newValue ? 0 : 1;
							return copy;
						});
					}),
				{
					loading: 'Updating Permission...',
					success: (data) => `${data.message}`,
					error: <b>Failed to update permission.</b>
				}
			);
		}

	};

	/* ----------------------------------------
	   Check / Uncheck ALL per Module
	---------------------------------------- */

	const handleModuleToggle = (module) => {
		const newValue = isModuleChecked(module) ? 0 : 1;

		setUserPermissionsList((oldData) =>
			oldData.map((m) => {
				if (m.id !== module.id) return m;

				return {
					...m,
					permissions: m.permissions.map((perm) => ({
						...perm,
						page_events: perm.page_events.map((e) => ({
							...e,
							has_permission: newValue
						}))
					}))
				};
			})
		);

		const pageEventIds = module.permissions.flatMap((perm) =>
			perm.page_events.map((e) => e.id)
		);

		const apiCall = data?.role
			? api.updateRolePermissions(data.role.id, {
					is_checked: newValue,
					page_event_ids: pageEventIds
			  })
			: api.updateUserPermissions(data.user.id, {
					is_checked: newValue,
					page_event_ids: pageEventIds
			  });

		toast.promise(apiCall, {
			loading: 'Updating Permissions...',
			success: (res) => res?.message,
			error: 'Failed to update permissions'
		});
	};

	
	return (
		<Scroller>
			<div className="user-permissions-box">
				{userPermissionsList?.map((module) => {
					return module?.permissions?.length > 0 && (
							<div className="user-permission-group">
								<div>
									<h4 className="flex" style={{ gap: '10px' }}>
										<input
											className="pm-checkbox"
											type="checkbox"
											checked={isModuleChecked(module)}
											onChange={() => handleModuleToggle(module)}
											disabled={!hasPerms(['Update User Permissions (Checkbox)'])}
										/>
										{module?.name}
									</h4>
								</div>

								{module?.permissions?.map((permission) => {
									return (
										<>
											<h6 className="permission-group-title">{permission?.name}</h6>
											<div className="permission-selectors">
												{permission?.page_events?.map((pEvent) => {
													return (
														<div className="pEvent-selector">
															<div
																className="myTest custom-control"
																style={{ display: 'flex', gap: '5px' }}
															>
																<input
																	type="checkbox"
																	className="pm-checkbox"
																	id={pEvent.name}
																	checked={pEvent?.has_permission}
																	onChange={(e) =>
																		handlePermissionEventCheck(pEvent.id, permission?.id, module?.id)
																	}
																	disabled={!hasPerms(['Update User Permissions (Checkbox)'])}
																/>
																<label
																	className=""
																	for={pEvent.name}
																	style={{ fontSize1: '12px', marginTop: '-1px' }}
																>
																	{pEvent?.name}
																</label>
															</div>
														</div>
													);
												})}
											</div>
										</>
									);
								})}
							</div>
					);
				})}
			</div>
		</Scroller>
	);
};

export default UserPermissions;
